import { render, staticRenderFns } from "./createNewPart1.vue?vue&type=template&id=bc040ee2&scoped=true&"
import script from "./createNewPart1.vue?vue&type=script&lang=js&"
export * from "./createNewPart1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc040ee2",
  null
  
)

export default component.exports